import toaster from "src/lib/toaster";
import { addToWishListTracking } from "src/services/analytics.service";
import { translate } from "src/services/translation.service";
import { IProduct } from "src/types/product";

import { IUserWish } from "../types";

export const addToWishList = async (
  product: IProduct,
  isAuthenticated: boolean,
  userWishAdd: IUserWish
): Promise<void> => {
  if (isAuthenticated) {
    await userWishAdd(product);
    toaster.notify(translate("toaster.productAddedToWishlist"));
    addToWishListTracking(product.name);
  } else {
    toaster.notify(translate("toaster.productAddedToWishlistNoSigned"));
  }
};

export const removeFromWishList = async (
  product: IProduct,
  userWishRemove: IUserWish
): Promise<void> => {
  await userWishRemove(product);
  toaster.notify(translate("toaster.productRemovedFromWishlist"));
};

export const handleWishListClick = (
  isWished: boolean,
  product: IProduct,
  isAuthenticated: boolean,
  userWishAdd: IUserWish,
  userWishRemove: IUserWish
): void => {
  isWished
    ? removeFromWishList(product, userWishRemove)
    : addToWishList(product, isAuthenticated, userWishAdd);
};
